import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Registration.css";
import apiClient from "./utils/apiClient";

const EmployeeRegistration = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const validateForm = () => {
    if (!formData.firstname || !formData.lastname) {
      alert("First Name and Last Name are required!");
      return false;
    }
    if (formData.Email !== formData.confirmemail) {
      alert("Email and Confirm Email must match!");
      return false;
    }
    if (formData.contactNumber && !/^\d{10}$/.test(formData.contactNumber)) {
      alert("Mobile number must be 10 digits!");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const formPayload = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (value !== undefined && value !== "") {
          formPayload.append(key, value);
        }
      });

      await apiClient.post("/employees/", formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Employee registered successfully!");
      setFormData({});
      navigate("/EmailAuth");

    } catch (error) {
      console.error("Error submitting form:", error);
      alert(
        error.response?.data?.message ||
        "Failed to register employee. Please try again."
      );
    }
  };

  const handleReset = () => {
    setFormData({});
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <div className="registration-container">
      <h2>Employee Registration</h2>

      <form onSubmit={handleSubmit} className="registration-form">
        <div className="form-grid">
          <label>
            First Name:
            <input
              type="text"
              name="firstname"
              value={formData.firstname || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Middle Name:
            <input
              type="text"
              name="middlename"
              value={formData.middlename || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Last Name:
            <input
              type="text"
              name="lastname"
              value={formData.lastname || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Gender:
            <select
              name="gender"
              value={formData.gender || ""}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </label>

          <label>
            Date of Birth:
            <input
              type="date"
              name="dob"
              value={formData.dob || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Photo:
            <input type="file" name="photo" onChange={handleChange} />
          </label>

          <label>
            Mobile Number:
            <input
              type="text"
              name="contactNumber"
              value={formData.contactNumber || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Email:
            <input
              type="email"
              name="Email"
              value={formData.Email || ""}
              onChange={handleChange}
            />
          </label>

          <label>
            Confirm Email:
            <input
              type="email"
              name="confirmemail"
              value={formData.confirmemail || ""}
              onChange={handleChange}
            />
          </label>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button">
            Submit
          </button>
          <button type="button" className="cancel-button" onClick={handleCancel}>
            Cancel
          </button>
          <button type="button" className="reset-button" onClick={handleReset}>
            Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmployeeRegistration;
